import api from '../../utils/api'

export const sendContactMessageApi = (data) => api.post('v1/messages', data)
